import ReactGA from "react-ga4";
import {
  Alert,
  Button,
  Stack,
  TextField,
  Typography,
  CircularProgress,
  Fade,
} from "@mui/material";
import { useFormControls } from "../hooks/useFormControls";
import ReCAPTCHA from "react-google-recaptcha";
import React from "react";

const inputFieldValues = [
  {
    name: "fullName",
    label: "Full Name",
    id: "my-name",
  },
  {
    name: "email",
    label: "Email",
    id: "my-email",
  },
  {
    name: "message",
    label: "Message",
    id: "my-message",
    multiline: true,
    rows: 10,
  },
];

function Contact() {
  const { setToken, handleInputValue, handleFormSubmit, formIsValid, errors } =
    useFormControls();
  const [sendResult, setSendResult] = React.useState("none");
  const [isSending, setIsSending] = React.useState(false);

  const reCaptchaRef = React.useRef();
  const submitForm = async (e) => {
    setIsSending(true);
    let result = await handleFormSubmit(e);
    if (result.error === true) {
      setIsSending(false);
      setSendResult("error");
    } else {
      setIsSending(false);
      setSendResult("sent");
    }
  };

  React.useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: "/contact",
      page_title: "Contact Page",
    });
  }, []);

  return (
    <Fade in={true} timeout={500}>
      <form onSubmit={submitForm}>
        <Stack direction="column" spacing={2} mb={4}>
          <Typography variant="h4">Get in touch</Typography>
          <Typography variant="body2">
            Do you have any question or suggestions? Feel free to reach out!
          </Typography>
          {sendResult === "error" && (
            <Alert severity="error">
              Error while sending the e-mail, feel free to contact us directly
              at contact[at]3dposes.com
            </Alert>
          )}
          {sendResult === "sent" && (
            <Alert severity="success">
              Thanks for contacting us! We will get back to you as soon as
              possible
            </Alert>
          )}
          {sendResult === "sent" ? (
            ""
          ) : (
            <>
              {inputFieldValues.map((inputFieldValue, index) => {
                return (
                  <TextField
                    key={index}
                    onBlur={handleInputValue}
                    onChange={handleInputValue}
                    name={inputFieldValue.name}
                    label={inputFieldValue.label}
                    multiline={inputFieldValue.multiline ?? false}
                    rows={inputFieldValue.rows ?? 1}
                    autoComplete="none"
                    {...(errors[inputFieldValue.name] && {
                      error: true,
                      helperText: errors[inputFieldValue.name],
                    })}
                  />
                );
              })}
              <ReCAPTCHA
                ref={reCaptchaRef}
                sitekey="6LfMNKAcAAAAAL-IU9NpT2Ar1q8m1PE3mucD_qHl"
                onChange={setToken}
              />
              <Button
                type="submit"
                variant="contained"
                disableElevation
                disabled={!formIsValid() || isSending}
              >
                {isSending ? (
                  <CircularProgress style={{ color: "white" }} />
                ) : (
                  "Submit"
                )}
              </Button>
            </>
          )}
        </Stack>
      </form>
    </Fade>
  );
}

export default Contact;
